import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Constants from './constants'

export const fetchDomains = () =>
Request.requestActionCreator(Constants.FETCH_DOMAINS)({
  method: 'GET',
  url: `${Constants.SERVER_RESOURCE}/domains`,
})

export const submitDomain = (community: string, domain: string) =>
Request.requestActionCreator(Constants.SUBMIT_NEW_DOMAIN)({
  method: 'POST',
  payload: {domain},
  url: `${Constants.SERVER_RESOURCE}/${community}/domains`,
})

export const deleteDomain = (domainId: number, emailConfigurationId: number) =>
Request.requestActionCreator(Constants.DELETE_DOMAIN)({
  method: 'DELETE',
  payload: {domainId, emailConfigurationId},
  url: `${Constants.SERVER_RESOURCE}/domains/delete`,
})

export const verifyDomain = (domainId: number, emailConfigurationId: number) =>
Request.requestActionCreator(Constants.VERIFY_DOMAIN)({
  method: 'POST',
  payload: {domainId, emailConfigurationId},
  url: `${Constants.SERVER_RESOURCE}/domains/verify`,
})

export const updateModalField: Modal.Update = Modal.updateModal(Constants.ADD_DOMAIN)



// WEBPACK FOOTER //
// ./src/pages/domain-authentication/actions.ts